<mat-form-field  class="my-custom-field"  [appearance]="formType"
 [ngClass]="{'my-custom-field': formType === 'standard',
  'my-custom-field-two': formType === 'newstandard'}" 
   fxFlex="100"
[formGroup]="group" >
<mat-label [ngClass]="{'my-custom-field': formType === 'standard', 'my-custom-field-two': formType === 'newstandard'}" class="white-text">{{field.label}}</mat-label>
<input [attr.guide]="'input-lead-inp-1' + '__' + sanitizeUrl(url)" [ngClass]="{'my-custom-field': formType === 'standard', 'my-custom-field-two': formType === 'newstandard'}" matInput [formControlName]="field.name"  [type]="field.inputType"/>
<ng-container *ngFor="let validation of field['dynamicFormLabelValidator'];" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
</ng-container>
</mat-form-field>

